import { Activity, useState } from 'react';

import { Chat } from '@mint-sdk/api-ai-assistant';

import { ProcessDetailsTabs } from './ProcessDetailsTabs.jsx';
import { KnowledgeBaseTabData } from './tabs/KnowledgeBaseTabData.jsx';
import { ReasoningTabData } from './tabs/ReasoningTabData.jsx';
import { WebSourceTabData } from './tabs/WebsourceTabData.jsx';

const getInitialActiveTab = ({
  reasoningData,
  knowledgeBaseSources,
}: {
  reasoningData: Chat.AiChatMessageRecordType[];
  knowledgeBaseSources: string[];
}) => {
  if (reasoningData.length > 0) {
    return 'reasoning';
  }

  if (knowledgeBaseSources?.length > 0) {
    return 'knowledgeBase';
  }

  return 'webSources';
};

type Props = {
  reasoningData: Chat.AiChatMessageRecordType[];
  webSources: string[];
  knowledgeBaseSources: string[];
};

const ProcessDetailsView = ({
  reasoningData,
  webSources,
  knowledgeBaseSources,
}: Props) => {
  const [activeTab, setActiveTab] = useState(() =>
    getInitialActiveTab({ reasoningData, knowledgeBaseSources }),
  );

  return (
    <div>
      <ProcessDetailsTabs
        activeTab={activeTab}
        onChangeTab={(tab) => setActiveTab(tab)}
        isStepsVisible={Boolean(reasoningData.length)}
        isKnowledgeVisible={Boolean(knowledgeBaseSources.length)}
        isWebsourceVisible={Boolean(webSources.length)}
      />

      <div className="p-2">
        <Activity mode={activeTab === 'reasoning' ? 'visible' : 'hidden'}>
          <ReasoningTabData reasoningMsg={reasoningData} />
        </Activity>
        <Activity mode={activeTab === 'knowledgeBase' ? 'visible' : 'hidden'}>
          <KnowledgeBaseTabData data={knowledgeBaseSources} />
        </Activity>
        <Activity mode={activeTab === 'webSources' ? 'visible' : 'hidden'}>
          <WebSourceTabData data={webSources} />
        </Activity>
      </div>
    </div>
  );
};

export { ProcessDetailsView };
